export function redirectToListing(listingId: number): void {
    document.location.href = `/${listingId}`;
}

export function guessByHost<A>(
    host: string,
    dev: A,
    test: (testEnv: string) => A,
    cute: (cuteEnv: string, cuteDomain: string) => A,
    prod: A
): A {
    if (
        ['dev.trademe.co.nz', 'sell.dev.trademe.co.nz'].some((u) =>
            host.endsWith(u)
        )
    ) {
        return dev;
    }

    const testMatch = /(integrate|stage|test\d\w).trademe.co.nz$/i.exec(host);
    if (testMatch) {
        return test(testMatch[1]);
    }

    const cuteMatch = new RegExp(
        '(?:www)\\.(.*?).(test\\.cutely\\..*)',
        'i'
    ).exec(host);

    if (cuteMatch) {
        return cute(cuteMatch[1], cuteMatch[2]);
    }

    return prod;
}

export const guessApiBaseUrl = (host: string, testEnv: string) =>
    guessByHost(
        host,
        `https://property-core-api.${testEnv}.trademe.co.nz`,
        (env) => `https://property-core-api.${env}.trade.me`,
        (env, domain) => `https://property-core-api.${env}.${domain}`,
        'https://property-core-api.prd.trade.me'
    );

export function removeOAuthArgs(url: string): string {
    return url.split('?').map(removeFromSearch).join('?');

    function removeFromSearch(search: string): string {
        return search
            .split('&')
            .filter((p) => !p.startsWith('oauth_'))
            .join('&');
    }
}

export function isWebview(search: string): boolean {
    return /from=(?:ios|android)/i.test(search || '');
}
